export const langsList = [
    "en","sq","ar","bs-BA","bg",
    "hr","cs","nl-BE","et","fr","de","hu",
    "id","it","lv","lt","mk","pl","pt",
    "ro","sr","sk","sl","es","uk"
] as const;
  
export type isoLang = typeof langsList[number];
  
export type langName =   
    "English"|"Albanian"|"Arabic"|"Bosnian"|"Bulgarian"|
    "Croatian"|"Czech"|"Dutch (BELGIUM)"|"Estonian"|"French"|"German"|"Hungarian"|
    "Indonesian"|"Italian"|"Latvian"|"Lithuanian"|"Macedonian"|"Polish"|"Portugese"|
    "Romanian"|"Serbian"|"Slovak"|"Slovenian"|"Spanish"|"Ukrainian";

type translation = {[id in nodeName]: string};

// Converts name of language in spreadsheet to the respective ISO
export const nameInSpreadsheet: {readonly [id in isoLang]: langName} = {
    "en"    :"English",
    "sq"    :"Albanian",
    "ar"    :"Arabic",
    "bs-BA" :"Bosnian",
    "bg"    :"Bulgarian",
    "hr"    :"Croatian",
    "cs"    :"Czech",
    "nl-BE" :"Dutch (BELGIUM)",
    "et"    :"Estonian",
    "fr"    :"French",
    "de"    :"German",
    "hu"    :"Hungarian",
    "id"    :"Indonesian",
    "it"    :"Italian",
    "lv"    :"Latvian",
    "lt"    :"Lithuanian",
    "mk"    :"Macedonian",
    "pl"    :"Polish",
    "pt"    :"Portugese",
    "ro"    :"Romanian",
    "sr"    :"Serbian",
    "sk"    :"Slovak",
    "sl"    :"Slovenian",
    "es"    :"Spanish",
    "uk"    :"Ukrainian"
}

export type nodeName = "confirmAgeCTA"|"tapBoxCTA";

export const dict_TLs: {[id in langName]: translation} = {
    "English": {
         "confirmAgeCTA":"You must confirm you're over 16 years of age or have your parents permission to enter this experience."
        ,"tapBoxCTA":"Tap this box to confirm"
    },
    "Albanian": {
         "confirmAgeCTA":"Ju duhet konfirmoni që jeni mbi 16 vjeç ose keni lejen e prindërve për të marrë pjesë në këtë përvojë."
        ,"tapBoxCTA":"Prekni kutinë për të konfirmuar"
    },
    "Arabic": {
         "confirmAgeCTA":"يجب أن يزيد عمرك عن 16 عاماً للمشاركة في هذه التجربة."
        ,"tapBoxCTA":"اضغط على المربع للمتابعة."
    },
    "Bosnian": {
         "confirmAgeCTA":"Morate potvrditi da imate više od 16 godina ili da imate dopuštenje roditelja za učestvovanje u ovom iskustvu."
        ,"tapBoxCTA":"Dodirnite ovaj okvir da potvrdite"
    },
    "Bulgarian": {
         "confirmAgeCTA":"Трябва да потвърдите, че сте<br>навършили 16 години, или че имате<br>разрешение от родител, за да<br>участвате в това изживяване."
        ,"tapBoxCTA":"Докоснете това поле, за да потвърдите"
    },
    "Croatian": {
         "confirmAgeCTA":"Za ovo iskustvo morate potvrditi da ste stariji od 16 godina ili dobiti dopuštenje od svojih roditelja."
        ,"tapBoxCTA":"Dodirnite okvir da biste potvrdili."
    },
    "Czech": {
         "confirmAgeCTA":"Je nutné potvrdit, že vám je více než 16 let, nebo že máte povolení rodičů k účasti na této hře."
        ,"tapBoxCTA":"Kliknutím na toto pole potvrďte"
    },
    "Dutch (BELGIUM)": {
         "confirmAgeCTA":"Je moet bevestigen dat je ouder<br>bent dan 16 jaar of toestemming van<br>je ouders hebt om aan deze<br>activiteit deel te nemen."
        ,"tapBoxCTA":"Tik op dit vak om te bevestigen"
    },
    "Estonian": {
         "confirmAgeCTA":"Pead kinnitama, et oled üle 16 aasta vana või sul on sisenemiseks vanema luba."
        ,"tapBoxCTA":"Kinnitamiseks vajuta kastile"
    },
    "French": {
         "confirmAgeCTA":"Vous devez confirmer avoir plus de 16 ans ou disposer de l'autorisation de vos parents pour accéder à ce jeu."
        ,"tapBoxCTA":"Cochez la case pour continuer"
    },
    "German": {
         "confirmAgeCTA":"Sie müssen bestätigen, dass Sie über 16 Jahre alt sind oder die Erlaubnis Ihrer Eltern haben, um auf diese Plattform zuzugreifen."
        ,"tapBoxCTA":"Klicken Sie das Kästchen an, um fortzufahren."
    },
    "Hungarian": {
         "confirmAgeCTA":"Meg kell erősítenie, hogy elmúlt 16 éves, vagy rendelkeznie kell szülői engedélyével az élményprogramban való részvételhez."
        ,"tapBoxCTA":"Koppintson a mezőre a megerősítéshez"
    },
    "Indonesian": {
         "confirmAgeCTA":"Kamu harus mengonfirmasi bahwa usiamu di atas 18 tahun, atau sudah mendapatkan izin orang tua untuk mengakses halaman ini"
        ,"tapBoxCTA":"Klik kotak ini untuk mengonfirmasi"
    },
    "Italian": {
         "confirmAgeCTA":"Devi confermare di avere più di 16<br>anni o avere il permesso dei tuoi genitori<br>per partecipare a questa esperienza."
        ,"tapBoxCTA":"Tocca questa casella per confermare"
    },
    "Latvian": {
         "confirmAgeCTA":"Jums jāapstiprina, ka esat vecāks par 16 gadiem vai jums ir vecāku atļauja, lai piedalītos šajā pieredzē."
        ,"tapBoxCTA":"Spiežat uz šo laukumu, lai apstiprinātu."
    },
    "Lithuanian": {
         "confirmAgeCTA":"Turite patvirtinti, kad esate vyresni nei 16 metų amžiaus, arba gauti tėvų leidimą, kad galėtumėte naudotis šia patirtimi."
        ,"tapBoxCTA":"Pažymėkite šį laukelį norėdami patvirtinti"
    },
    "Macedonian": {
         "confirmAgeCTA":"Мора да потврдите дека сте постари од 16 години или дека имате дозвола од родителите за ова доживување."
        ,"tapBoxCTA":"Допрете го полево за да потврдите"
    },
    "Polish": {
         "confirmAgeCTA":"Potwierdź, że masz ukończone 16 lat lub zgodę rodzica, aby kontynuować."
        ,"tapBoxCTA":"Zaznacz to pole, aby potwierdzić."
    },
    "Portugese": {
         "confirmAgeCTA":"Deves confirmar que tens mais de 16 anos ou ter a permissão dos teus pais para entrar nesta experiência."
        ,"tapBoxCTA":"Marque a caixa para continuar"
    },
    "Romanian": {
         "confirmAgeCTA":"Trebuie să confirmați că aveți peste 16 ani sau să aveți permisiunea părinților pentru a intra în această experiență."
        ,"tapBoxCTA":"Atingeți această casetă pentru a confirma."
    },
    "Serbian": {
         "confirmAgeCTA":"Morate da potvrdite da ste stariji od 16 godina ili da imate dozvolu roditelja da pristupite ovom iskustvu."
        ,"tapBoxCTA":"Dodirnite ovo polje da biste potvrdili"
    },
    "Slovak": {
         "confirmAgeCTA":"Musíte potvrdiť, že máte viac ako 16 rokov, alebo že máte povolenie od rodičov na účasť v tejto hre"
        ,"tapBoxCTA":"Kliknutím na toto políčko potvrdíte"
    },
    "Slovenian": {
         "confirmAgeCTA":"Za sodelovanje v tej izkušnji morate potrditi, da ste starejši od 16 let oziroma imate dovoljenje staršev."
        ,"tapBoxCTA":"Tapnite to polje za potrditev."
    },
    "Spanish": {
         "confirmAgeCTA":"Debes confirmar que tienes más de 16 años o tener el permiso de tus padres para participar en esta experiencia."
        ,"tapBoxCTA":"Toca esta casilla para confirmar"
    },
    "Ukrainian": {
         "confirmAgeCTA":"Ви повинні підтвердити, що вам більше 16 років або мати дозвіл батьків для доступу до цієї гри."
        ,"tapBoxCTA":"Позначте коробку, щоб продовжити"
    }
}